import '../../modules/mode-components';

import * as angular from 'angular';

class OSPickerController {
  static $inject = ['$timeout'];

  private tabs = [
    { type: 'osx', display: 'OSX', active: false },
    { type: 'ubuntu', display: 'Ubuntu', active: false },
    { type: 'centos', display: 'CentOS', active: false },
    { type: 'debian', display: 'Debian', active: false },
    { type: 'redhat', display: 'Redhat', active: false },
    { type: 'windows', display: 'Windows', active: false },
  ];
  private content: string;

  constructor(private $timeout) {}

  // currentTab is when clicked and content changed.
  // active is for hover state.
  select(selectedTab) {
    this.tabs.forEach((tab: any) => {
      tab.active = false;
      tab.currentTab = false;
    });
    selectedTab.active = true;
    selectedTab.currentTab = true;
    this.content = selectedTab.type;
  }

  mouseenterTab(tab) {
    this.$timeout(() => {
      tab.active = true;
    }, 0);
  }

  mouseleaveTab(tab) {
    if (!tab.currentTab) {
      tab.active = false;
    }
  }
}

const OSPickerComponent: angular.IComponentOptions = {
  bindings: {},
  controller: OSPickerController,
  controllerAs: 'ctrl',
  template: `
<div class="data-sources-container clearfix">
   <h3><i class="icon-bridge-step-1 bridge-icon mdlg-icon align-md-icon"></i> Choose your Operating System:</h3>

  <div class="os-items">
    <os-item
      ng-repeat="tab in ctrl.tabs"
      ng-click="ctrl.select(tab)"
      ng-class="{'selected':tab.currentTab}"
      class="selector-item"
      name="{{tab.display}}"
    ></os-item>
  </div>
</div>

<div class="install-instructions">
  <div class="connect-step-title" ng-class="{'active':ctrl.content}">
    <h3><i class="icon-bridge-step-2-default bridge-icon mdlg-icon align-md-icon"></i> Install</h3>
  </div>

  <div class="instructions-container">
    <div ng-show="ctrl.content == 'osx'" ng-transclude="osx" ng-cloak></div>
    <div id="ubuntu-content" ng-show="ctrl.content == 'ubuntu' || ctrl.content == 'debian'" ng-transclude="linux" ng-cloak></div>
    <div id="redhat-content" ng-show="ctrl.content == 'redhat' || ctrl.content == 'centos'" ng-transclude="redhat" ng-cloak></div>
    <div id="windows-content" ng-show="ctrl.content == 'windows'" ng-transclude="windows" ng-cloak></div>
  </div>
</div>

<div ng-transclude="footerLeft"></div>
<div ng-show="ctrl.content" ng-transclude="footerRight"></div>
  `,
  transclude: {
    osx: 'osPickerTabOsx',
    linux: 'osPickerTabLinux',
    redhat: 'osPickerTabRedhat',
    windows: 'osPickerTabWindows',
    footerLeft: 'footerLeft',
    footerRight: 'footerRight',
  },
};

angular.module('mode.components').component('osPicker', OSPickerComponent);
